import { useQuery } from '@tanstack/react-query';
import { nationalityApi } from '../api/nationality.api';
import { nationalityKeys } from '../api/nationality.keys';

export function useNationalityDetails(id: any) {
  return useQuery({
    queryKey: nationalityKeys.detail(id),
    queryFn: () => nationalityApi.getById(id),
    enabled: !!id,
  });
}
